
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Link, Image, Tracking } from 'contentbricks'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <Image className='bigImage' file={require('images/grafik_aura.jpg')} mdxType="Image" />
    <p>{`Eindeutiges Zeichen ist die «Aura». Sie tritt aber nur bei etwa einem oder zwei
von zehn Betroffenen auf. Meist sind das rund 30 Minuten anhaltende Sehstörungen
in Form von flimmernden Punkten, Zickzacklinien, Schlieren oder Schleiern, die
sich allmählich ausbreiten. Selten zeigt sich die Aura an Schwindel,
Sprachstörungen oder anderen, kurzzeitig auftretenden neurologischen Symptomen.
Eine Migräneattacke hält maximal 72 Stunden an, im Gegensatz zum
Spannungskopfschmerz, der sogar eine ganze Woche dauern kann. Bei der Migräne
verstärkt sich der Kopfschmerz durch körperliche Aktivität, beim
Spannungskopfschmerz dagegen kann körperliche Aktivität oder Ablenkung sogar die
Schmerzen lindern. Ein anderes Unterscheidungsmerkmal sind Übelkeit und
Erbrechen sowie die Reizüberempfindlichkeit gegen Licht und Lärm. Dies tritt bei
Spannungskopfschmerzen nicht auf.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;